import { HalachicEngine } from '../../engine';

let engineInstance = null;

/**
 * Get or create the engine singleton.
 */
function getEngine(config) {
  if (!engineInstance) {
    engineInstance = new HalachicEngine(config);
  }
  return engineInstance;
}

// Action Creators
export const startHalachicEngine = () => ({ type: 'HALACHIC_ENGINE_START' });
export const successHalachicEngine = (payload) => ({ type: 'HALACHIC_ENGINE_SUCCESS', payload });
export const failedHalachicEngine = (error) => ({ type: 'HALACHIC_ENGINE_ERROR', payload: error });
export const clearHalachicEngine = () => ({ type: 'HALACHIC_ENGINE_CLEAR' });

/**
 * Compute halachic data for today and tomorrow.
 *
 * @param {object} config - { location: { lat, lng, timezone }, isIsrael, edah, ... }
 * @returns {Function} Redux thunk
 */
export const fetchHalachicData = (config) => {
  return async (dispatch) => {
    dispatch(startHalachicEngine());

    try {
      const engine = getEngine(config);
      engine.updateConfig(config);

      const { today, tomorrow } = await engine.computeTodayAndTomorrow();
      dispatch(successHalachicEngine({ today, tomorrow }));
    } catch (error) {
      console.error('Halachic engine error:', error);
      dispatch(failedHalachicEngine(error.message));
    }
  };
};

// Range Action Creators
export const startHalachicRange = () => ({ type: 'HALACHIC_ENGINE_RANGE_START' });
export const successHalachicRange = (payload) => ({ type: 'HALACHIC_ENGINE_RANGE_SUCCESS', payload });
export const failedHalachicRange = (error) => ({ type: 'HALACHIC_ENGINE_RANGE_ERROR', payload: error });

/**
 * Compute halachic data for a range of days (lookahead).
 *
 * @param {object} config - engine config
 * @param {number} [daysCount=7] - number of days to compute
 * @returns {Function} Redux thunk
 */
export const fetchHalachicRange = (config, daysCount = 7) => {
  return async (dispatch) => {
    dispatch(startHalachicRange());

    try {
      const engine = getEngine(config);
      engine.updateConfig(config);

      const range = await engine.computeRange(new Date(), daysCount);
      dispatch(successHalachicRange({ range }));
    } catch (error) {
      console.error('Halachic range error:', error);
      dispatch(failedHalachicRange(error.message));
    }
  };
};

/**
 * Force recompute (clears internal cache).
 */
export const refreshHalachicData = (config) => {
  return async (dispatch) => {
    const { clearCache } = await import('../../engine');
    clearCache();
    engineInstance = null;
    dispatch(fetchHalachicData(config));
  };
};
